<template>
    <div class="company-container">
        <!-- 轮播图 -->
        <Slide/>
        <!-- 轮播图 -->
        <!-- 公司介绍 -->
        <div class="row img-row">
            <div class="col-sm-6 c-img">
                <img src="../assets/images/asset-3.png" alt="">
            </div>
            <div class="col-sm-6">
                <div class="c-text">
                    <h1 v-html="$t('home.worldMolding.title')"></h1>
                    <p>{{$t('home.worldMolding.text')}}</p>
                    <router-link class="btn" to="/InjectionMolding">{{$t('common.learnMore')}}</router-link>
                </div>
            </div>
        </div>
        <!-- GETAC -->
        <div class="getac-row">
            <div class="getac-row-content">
                <div class="row getac-row-content-text">
                    <div class="col-sm-6">
                        <img class="getac-img-logo img-responsive" src="../assets/images/dell_logo_white.svg" alt="">
                        <h1>{{$t('home.dell.title')}}</h1>
                        <p>{{$t('home.dell.text')}}</p>                       
                    </div>
                    <div class="col-sm-6">
                        <div class="getac-img-box">
                            <img class="img-responsive" src="../assets/images/inter_img.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- TEAMS -->
        <div class="teams-row">
            <div class="row">
                <h1>{{$t('common.trustedBy')}}</h1>
                <ul class="teams-img-list">
                    <li v-for="(item,index) in teamsImg" :key="index">
                        <img class="img-responsive" :src="item.url" alt="">
                    </li>
                </ul>
            </div>
        </div>
        <!-- sevices -->
        <div class="sevices-row">
            <div class="row">
                <div class="col-sm-6 sevice-left">
                    <div class="sevice-img-box">
                        <img class="img-responsive" src="../assets/images/sevice_img.png" alt="">
                    </div>
                </div>
                <div class="col-sm-6 sevice-content">
                    <h1>{{$t('home.sevices.title')}}</h1>
                    <ul>
                        <li v-for="(item,index) in sevIcon[$i18n.locale]" :key="index">
                            <img class="img-responsive" :src="item.url" alt="">
                            <span>{{item.title}}</span>
                        </li>
                    </ul>
                    <p>{{$t('home.sevices.text')}}</p>
                    <router-link class="btn" to="/Capabilities">{{$t('common.learnMore')}}</router-link>
                </div>
            </div>
        </div>
        <!-- INDUSTRIES -->
        <div class="indus-row">
            <div class="row injectMold-row">
                <div class="col-sm-6 indus-img show">
                    <img class="img-responsive" src="../assets/images/injectmold_img.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('home.injectMold.title')}}</h1>
                    <p>{{$t('home.injectMold.text')}}</p>
                    <router-link class="btn" to="/InjectionMolding">{{$t('common.learnMore')}}</router-link>
                </div>
                <div class="col-sm-6 indus-img hide">
                    <img class="img-responsive" src="../assets/images/injectmold_img.png" alt="">
                </div>
            </div>
            <div class="row metal-row">
                <div class="col-sm-6 indus-img">
                    <img class="img-responsive" src="../assets/images/metal.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('home.metal.title')}}</h1>
                    <p>{{$t('home.metal.text')}}</p>
                    <router-link class="btn" to="/Forming">{{$t('common.learnMore')}}</router-link>
                </div>
            </div>
            <div class="row finishing-row">
                <div class="col-sm-6 indus-img show">
                    <img class="img-responsive" src="../assets/images/finishing.png" alt="">
                </div>
                <div class="col-sm-6 indus-text">
                    <h1>{{$t('home.finishing.title')}}</h1>
                    <p>{{$t('home.finishing.text')}}</p>
                    <router-link class="btn" to="/Surface">{{$t('common.learnMore')}}</router-link>
                </div>
                <div class="col-sm-6 indus-img hide">
                    <img class="img-responsive" src="../assets/images/finishing.png" alt="">
                </div>
            </div>
        </div>
        <!-- events -->
        <!-- <div class="events-row">
            <div class="row">
                <div class="col-sm-6">
                    <h1>2021 CES EVENT</h1>
                    <p>AENEAN UT EROS ET NISL SAGITTIS VESTIBULUM. NULLAM NULLA EROS, ULTRICIES SIT AMET, NONUMMY ID, IMPERDIET FEUGIAT, PEDE. SED LECTUS. DONEC MOLLIS HENDRERIT RISUS. PHASELLUS NEC SEM IN JUSTO PELLENTESQUE FACILISIS. ETIAM IMPERDIET IMPERDIET ORCI. NUNC NEC NEQUE. PHASELLUS LEO DOLOR, TEMPUS NON, AUCTOR ET, HENDRERIT QUIS, NISI. CURABITUR LIGULA SAPIEN, TINCIDUNT NON, EUISMOD VITAE, POSUERE IMPERDIET, LEO. MAECENAS MALESUADA. PRAESENT CONGUE ERAT AT MASSA. SED CURSUS TURPIS VITAE TORTOR. DONEC POSUERE VULPUTATE ARCU. PHASELLUS ACCUMSAN CURSUS VELIT. VESTIBULUM ANTE IPSUM PRIMIS IN FAUCIBUS ORCI LUCTUS ET ULTRICES POSUERE CUBILIA CURAE; SED ALIQUAM, NISI QUIS PORTTITOR CONGUE, ELIT ERAT EUISMOD ORCI, AC</p>
                    <router-link to="/News" class="btn">Learn More</router-link>
                </div>
                <div class="col-sm-6">
                    <h1>HYBRID MOLDING</h1>
                    <p>IMPERDIET A, VENENATIS VITAE, JUSTO. NULLAM DICTUM FELIS EU PEDE MOLLIS PRETIUM. INTEGER TINCIDUNT. CRAS DAPIBUS. VIVAMUS ELEMENTUM SEMPER NISI. AENEAN VULPUTATE ELEIFEND TELLUS.AENEAN LEO LIGULA, PORTTITOR EU, CONSEQUAT VITAE, ELEIFEND AC, ENIM. ALIQUAM LOREM ANTE, DAPIBUS IN, VIVERRA QUIS, FEUGIAT A, TELLUS. PHASELLUS VIVERRA NULLA UT METUS VARIUS LAOREET. QUISQUE RUTRUM. AENEAN IMPERDIET. ETIAM ULTRICIES NISI VEL AUG</p>
                    <router-link to="/News" class="btn">Learn More</router-link>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    import Slide from '../components/Slide/Slide'
    export default {
        data() {
            return {
                industries:[],
                sevIcon:{
                    EN:[
                        {
                            url:require('../assets/images/Design.png'),
                            title:"DESIGN",
                        },{
                            url:require('../assets/images/CNC.png'),
                            title:"CNC",
                        },{
                            url:require('../assets/images/Factory.png'),
                            title:"Prototype Designing",
                        }
                    ],
                    CN:[
                        {
                            url:require('../assets/images/Design.png'),
                            title:"外观及内构设计"
                        },{
                            url:require('../assets/images/CNC.png'),
                            title:"CNC"
                        },{
                            url:require('../assets/images/Factory.png'),
                            title:"模型设计"
                        }
                    ],
                    CHT:[
                        {
                            url:require('../assets/images/Design.png'),
                            title:"外觀及內構設計",
                        },{
                            url:require('../assets/images/CNC.png'),
                            title:"CNC",
                        },{
                            url:require('../assets/images/Factory.png'),
                            title:"模型設計",
                        }
                    ],
                    JP:[
                        {
                            url:require('../assets/images/Design.png'),
                            title:"外観及び内部構造設計",
                        },{
                            url:require('../assets/images/CNC.png'),
                            title:"CNC",
                        },{
                            url:require('../assets/images/Factory.png'),
                            title:"PROTOTYPING",
                        }
                    ]
                },
                teamsImg:[
                    {url:require('../assets/images/ProgressMark_logo.png')},
                    {url:require('../assets/images/sony_logo_black.png')},
                    {url:require('../assets/images/Nvidia-logo_black.png')},
                    {url:require('../assets/images/Dell_logo_black.png')},
                    {url:require('../assets/images/inter_logo_black.png')},
                    {url:require('../assets/images/lenovo-logo-black.png')},
                    {url:require('../assets/images/asus-logo-black.png')}
                ]
            }
        },
        components:{
            Slide
        },
        created(){
            // window.addEventListener('resize',this.getImgHeight)
        },
        mounted(){
            $(document).ready(function(){
                if($(window).width()>768){
                    $(".sevice-img-box").height($(".sevice-content").height());
                }
            })
            this.getIndustries();
        },
        methods:{
            getIndustries () {
                this.$api.industries.industriesList().then(res=>{
                    this.industries = res.data.result
                    console.log(res.data.result)
                }).catch(
                    (error) => {
                        console.log(error)
                    }
                )
            }
        }
    }
</script>
<style scoped>
    .img-row{
        margin:12rem auto;
    }
    .c-img img{
        width:100%;
    }
    .c-text h1{
        text-align: left;
        font-size: 4.8rem;
        font-weight: 700;
        color: #00457A;
        line-height: 1.2;
    }
    .c-text p{
        width: auto;
        text-align: left;
        font-size: 2rem;
        margin:2rem 0;
        overflow: hidden;
    }
    .getac-row{
        width:100%;
        background:#29AAE1;
        background-size: cover;
        padding:4rem 0;
    }
    .getac-row-content-text{
        max-width: 1200px;
        margin:0 auto;
    }
    .getac-row-content-text h1{
        color:#fff;
        font-size: 3.6rem;
        font-weight: 700;
        text-align: left;
        margin-bottom: 4rem;
        margin-top: 6rem;
    }
    .getac-row-content-text  p{
        width: 100%;
        color:#fff;
        font-size: 1.4rem;
        text-align: left;
        margin:1rem 0;
    }
    .getac-img-box{
        border:25px solid #fff;
    }
    .getac-img-logo{
        width:15rem;
    }
    .sevices-row{
        width:100%;
        background:#091932;
        padding:2rem 0;
    }
    .sevices-row h1{
        font-size: 4.8rem;
        color:#fff;
        font-weight: 700;
        text-align: left;
    }
    .sevices-row p{
        width: 100%;
        color:#fff;
        font-size: 2rem;
        text-align: left;
        margin:4rem 0;
    }
    .sevice-content{
        padding-left: 8rem;
    }
    .sevices-row ul{
        margin-top:4rem
    }
    .sevices-row ul li{
        overflow: hidden;
        margin-top: 2rem;
    }
    .sevices-row ul li img{
        float: left;
        width:6rem;
        margin: 0 auto;
    }
    .sevices-row ul li span{
        float: left;
        font-size: 1.4rem;
        font-weight: bold;
        color: #fff;
        margin-top: 2rem;
        margin-left: 2rem;
    }
    .sevice-img-box{
        display: table-cell;
        vertical-align: middle;
        width: 100%;
    }
    .sevice-img-box img{
        width: 100%;
        border:25px solid #fff;
    }
    .teams-row{
        width:100%;
        background:#fff;
    }
    .teams-row .row{
        margin-top: 0;
        margin-bottom: 0;
    }
    .teams-row h1{
        font-size: 2rem;
        font-weight: 700;
        margin:4rem 0;
    }
    .teams-row ul{
        width: 100%;
        margin-bottom: 4rem;
    }
    .teams-row ul li{
        display: table-cell;
        text-align: center;
        width: 1%;
        padding: 1rem;
    }
    .teams-row ul li img{
        max-width:100%;
        height: auto;
    }
    .indus-row .row{
        margin-bottom: 0;
        margin-top: 0;
        max-width: 100%;
    }
    .indus-row .mater-row{
        padding-right: 100px;
    }
    .indus-row h1{
        text-align: left;
        font-size:4.8rem;
        font-weight: 700;
        margin-bottom: 2rem;
        color: #00457A;
    }
    .indus-row p{
        text-align: left;
        width: 100%;
        margin-bottom: 2rem;
    }
    .indus-text{
        padding:10rem;
        padding-bottom: 0;
    }
    .metal-row .indus-text,.finishing-row .indus-text{
        padding-top: 25rem;
    }
    .indus-img{
        background: #00457A;
        padding: 10rem;
    }
    .metal-row .indus-img{
        background: #091932;
    }
    .finishing-row .indus-img{
        background:#29AAE1;
    }
    .indus-list{
        overflow: hidden;
    }
    .indus-list li{
        float:left;
        width:33.3333333%;
        padding:0 1rem;
        margin-top: 1rem;
    }
    .indus-list li img{
        max-width: 100%;
        height:auto;
        display: block;
        margin:0 auto;
    }
    .indus-list li h2{
        margin-top: 2rem;
        font-weight: 700;
        font-size: 1.4rem;
    }
    .indus-list li p{
        width:100%;
        font-size: 1.4rem;
        height:6rem;
        line-height: 2rem;
        overflow: hidden;
        margin:2rem 0;
        text-align: left;
    }
    .events-row .row{
        max-width: 100%;
        margin: 0 auto;
    }
    .events-row .col-sm-6{
        padding:5rem 10rem;
    }
    .events-row .col-sm-6:first-child{
        background:url(../assets/images/shutterstock_732811756.png) left top no-repeat;
        background-size: cover;
    }
    .events-row .col-sm-6:last-child{
        background:url(../assets/images/3cbf5eabbde02cad7a36c47d408b5e58.png) left top no-repeat;
        background-size: cover;
    }
    .events-row h1{
        font-size: 3rem;
        color:#fff;
        font-weight: 700;
        text-align: left;
        margin-bottom: 2rem;
    }
    .events-row p{
        width:100%;
        font-size: 2rem;
        color:#fff;
        text-align: left;
        line-height: 3rem;
        height:9rem;
        overflow: hidden; 
        text-overflow: ellipsis; 
        margin: initial;
        margin-bottom: 2rem;
    }
    .show{
        display: none !important;
    }
    .hide{
        display: block !important;
    }
    @media (min-width: 768px) and (max-width: 1024px){
        .getac-row-content-text h1{
            margin-top: 2.5rem;
            font-size: 2.4rem;
        }
        .c-text h1{
            font-size: 2.4rem;
        }
        .img-row{
            margin:4rem auto;
        }
        .c-text p{
            margin:1rem 0;
        }
        .sevice-content{
            padding-left: 2rem;
        }
        .sevices-row h1{
            font-size: 2.4rem;
        }
        .sevices-row p{
            font-size: 1.4rem;
        }
        .indus-text{
            padding: 4rem;
        }
        .indus-img{
            padding:4rem
        }
        .indus-row h1{
            font-size: 2.4rem;
        }
        .metal-row .indus-text, .finishing-row .indus-text{
            padding-top: 6rem;
        }
    }
    @media (max-width: 767px){
        .img-row{
            margin:1rem auto;
        }
        .c-text{
            margin-top: 0;
        }
        .c-text h1{
            text-align: center;
            margin:1rem 0;
            font-size: 1.2rem;
        }
        .c-text p{
            font-size: 0.7rem;
            margin:0.5rem 0;
        }
        .c-text p~.btn{
            margin:1rem auto;
            margin-bottom: 0;
        }
        .getac-row{
            padding:2rem 0;
        }
        .getac-img-logo{
            width: 5rem;
            margin:0 auto;
        }
        .getac-row-content-text h1{
            font-size: 1rem;
            margin-top:1rem;
            margin-bottom: 1rem;
            text-align: center;
        }
        .getac-row-content-text p{
            font-size: 0.7rem;
            line-height: 1.5;
            text-align: center;
        }
        .sevices-row .row{
            margin:0 auto;
        }
        .sevice-content{
            padding-left: 15px;
        }
        .sevices-row h1{
            text-align: center;
            font-size: 1.5rem;
            margin-top: 1rem;
        }
        .sevices-row .row p{
            font-size: 0.7rem;
            margin:1rem 0;
            padding:0;
        }
        .sevices-row .btn{
            margin:1rem auto
        }
        .sevices-row ul{
            margin-top: 2rem;
            padding-left: 2rem;
            margin-bottom: 2rem;
        }
        .sevices-row ul li{
            margin-top: 1rem;
        }
        .sevices-row ul li img{
            width: 3rem;
        }
        .sevices-row ul li span{
            font-size: 0.7rem;
            margin-top: 1rem;
        }
        .teams-row h1{
            font-size: 1.2rem;
            margin:1rem 0;
        }
        .teams-row ul{
            margin-bottom: 1rem;
        }
        .teams-row ul li{
            padding:0.2rem
        }
        .metal-row .indus-text,.finishing-row .indus-text{
            padding-top: 2rem;
        }
        .indus-row .injectMold-row{
            margin-bottom: 0 !important;
        }
        .indus-row h1{
            font-size: 1.2rem;
            margin-bottom:2rem ;
            text-align: center;
        }
        .indus-text{
            padding: 40px 15px;
            padding-top: 2rem;
            overflow: hidden;
        }
        .indus-text p{
            width: 100%;
            text-align: center;
            padding: 0;
        }
        .indus-img{
            padding:1rem;
        }
        .events-row{
            margin-bottom: 0;
        }
        .events-row .col-sm-6{
            padding:2rem;
        }
        .events-row h1{
            font-size: 0.9rem;
            text-align: center;
            margin-bottom: 1rem;
        }
        .events-row p{
            font-size: 0.7rem;
            height:4rem;
            line-height: 1rem;
        }
        .events-row .btn{
            margin:1rem auto;
            margin-bottom: 0;
        }
        .show{
            display: block !important;
        }
        .hide{
            display: none !important;
        }
    }
    
</style>




// WEBPACK FOOTER //
// src/views/home.vue